import type { CSSProperties } from 'react';
import { ACCOUNT_COLORS, tint } from './accountColors';   // the app's green at source: teal.accent = --accent
import { lighten } from '../tabPalette';

// ── SLF Property's bubbles: green and white ──────────────────────────────────────────────────────
// Every list in the SLF Property console draws ONE BUBBLE PER ROW, where each tab used to draw a
// single bordered box of rows parted by thin grey hairlines. Calem asked for it tab by tab — Due
// Diligence first (report d0b44032: "change the following due diligence to bubbles rather than just
// lines"), then Legal Matters (report 19597a46: "represented with green and white bubbles"), and on
// that report's 3rd opening for the rest of the strip: "Bubble everything in the menu below (except
// Lease Registration), separate the bubbles, and give them all a green border and a green ID number,
// if applicable". So POA, Last Will and the Property Form wear it too, and only Lease Registration
// keeps its table.
//
// The colours are the app's own green accent, not a theme of this console's: report d0b44032 painted
// the console the SLF Property pink and Calem sent that back on its 2nd opening ("Change the color
// back to green and white but keep the bubbles"). A bubble is therefore plain white with a 1px green
// edge and 10px corners; hover takes it one shade down into the green family — the accent's pale wash
// two shades lighter, the faintest green the app makes — so a hovered bubble lifts without the page
// changing colour. The cards stand 10px apart on the page, Tracking's gap, so the page shows between
// them.
//
// They live here rather than in each module because four lists now share them (DueDiligence, Poa,
// LastWill, PropertyForm) plus Legal Matters' 'property' desk (Workflows): one place to change, and
// the same arithmetic is not written out five times. The report / POA / will / form number stays
// var(--accent), the solid green, which is the "green ID number" asked for; Legal Matters has no
// number of its own, which is what "if applicable" covers.
export const PROP_LINE = tint(ACCOUNT_COLORS.teal.accent, 0.51);   // the green edge, the weight every coloured box draws its line at
export const PROP_CARD_BG = 'var(--bg-surface)';                   // plain white, the fill the console's forms give their cards
export const PROP_CARD_HOVER = lighten(ACCOUNT_COLORS.teal.bg, 2); // #E1F5EE two shades lighter — the palest green the app makes

export const propCard: CSSProperties = { background: PROP_CARD_BG, border: `1px solid ${PROP_LINE}`, borderRadius: 10 };
